import type { DashboardItem } from '../types/dashboard.types';

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null;

const OPTIONAL_STRING_FIELDS = [
    'reference',
    'status',
    'vehicle_make_name',
    'vehicle_model_name',
    'vehicle_vrm',
    'vehicle_vin',
] as const;

const NULLABLE_STRING_FIELDS = ['agreement_id', 'quote_id', 'plan_id', 'created_at_ts'] as const;

const isNullableString = (value: unknown): boolean => value === null || typeof value === 'string';

export const isThirdPartyItem = (value: unknown): value is DashboardItem =>
    isRecord(value) &&
    typeof value.id === 'string' &&
    value.source === 'third_party' &&
    value.record_type === 'plan' &&
    typeof value.record_id === 'string' &&
    'dealer_id' in value &&
    isNullableString(value.dealer_id) &&
    OPTIONAL_STRING_FIELDS.every((field) => value[field] === undefined || typeof value[field] === 'string') &&
    NULLABLE_STRING_FIELDS.every((field) => value[field] === undefined || isNullableString(value[field]));
